<script>
import { mapActions } from 'vuex';
import { cloneDeep, result } from 'lodash';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'NewOrganizationalUnitDialog',
  components: {
  },
  mixins: [snackbarMixin, validatorMixin],
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        name: { required: true },
      },
      baseFormData: {
        name: '',
      },
      formData: {},
    };
  },
  created() {
    this.formData = cloneDeep(this.baseFormData);
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('organizationalUnitDetails', ['saveOrganizationalUnit']),
    ...mapActions('organizationalUnitList', { fetchData: 'fetchOrganizationalUnitList' }),
    submit(type) {
      if (!this.validateForm()) return false;

      this.isLoading = true;

      return this.saveOrganizationalUnit(this.formData)
        .then(({ data }) => {
          this.showSuccessMessage('Organisationseinheit erfolgreich erstellt!');

          if (type === 'new') {
            this.formData = cloneDeep(this.baseFormData);
          } else {
            this.close();

            if (type === 'detail') {
              this.$router.push(`/organizationalUnit/${data.id}`);
            }
          }
          this.fetchData();
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Fehler beim Erstellen der Organisationseinheit. Bitte versuche es erneut!');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Neue Organisationseinheit
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12 xs12>
              <h4 class="organizationalUnit-detail-tab-title">Stammdaten</h4>
              <v-layout row wrap>

                <v-flex xs12 md4 py-0>
                  <v-text-field
                    v-model="formData.name"
                    :error-messages="validationErrorMessages.name"
                    label="Name"
                    height="22"
                    class="caption"
                  />
                </v-flex>

              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>

        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>

        <v-menu bottom left>
          <v-btn slot="activator" icon>
            <v-icon>expand_more</v-icon>
          </v-btn>

          <v-list>

            <v-list-tile>
              <v-list-tile-title @click="submit('new')">
                Speichern &amp; Neu
              </v-list-tile-title>
            </v-list-tile>

            <v-list-tile>
              <v-list-tile-title @click="submit('detail')">
                Speichern &amp; Detail
              </v-list-tile-title>
            </v-list-tile>

          </v-list>
        </v-menu>

      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
